// extracted by mini-css-extract-plugin
export default {"wrapper":"mu-z","response":"nu-z","error":"ou-z","disabled":"pu-z","buttons":"qu-z","feedbackQuestionSection":"ru-z","yesNoWrapper":"su-z"};